import actions from './index';
import { BASE_URL } from '../constants/api';

export const ACTIONS = {
  GET: 'PROGRAM_ANALYTICS_GET',
  GET_SUCCESS: 'PROGRAM_ANALYTICS_GET_SUCCESS',
  GET_FAILURE: 'PROGRAM_ANALYTICS_GET_FAILURE',
  INVALIDATE_ITEM: 'PROGRAM_ANALYTICS_INVALIDATE_ITEM',
  GET_ALL: 'PROGRAM_ANALYTICS_GET_ALL',
  GET_ALL_SUCCESS: 'PROGRAM_ANALYTICS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'PROGRAM_ANALYTICS_GET_ALL_FAILURE',
};

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  ({ programId }) => `${BASE_URL}/insightsreader/program-aggregate/${programId}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
